// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets-site/css/" + chunkId + "." + "7b3fec66" + ".css";
};